<template>
  <hr class="horizontal" style="margin: 8px 0" />
  <div class="d-flex-column justify-start align-start gap-16">
    <BoostingMethodPicker />
    <DivisionsPicker
      v-if="checkoutStore.getDetails?.boostType === 'Division Boost'"
    />
    <ObjectivePicker
      v-else-if="checkoutStore.getDetails?.boostType === 'Qualification Points'"
      :title="$t('fc-boost.rival_points')"
      :description="$t('fc-boost.select_rival_points')"
      :min="50"
      :max="1250"
      :step="50"
      :steps="steps"
      item-key="numberOfRivalPoints"
    />
    <PlatformSelector />
    <ExtraOptionPicker />
    <AddOnPicker title="path_of_exile.addons" />
  </div>
  <hr class="horizontal md-hide" style="margin: 8px 0" />
</template>

<script setup>
import BoostingMethodPicker from "./pickers/BoostingMethodPicker.vue";
import PlatformSelector from "./pickers/PlatformSelector.vue";
import ExtraOptionPicker from "./pickers/ExtraOptionPicker.vue";
import DivisionsPicker from "./pickers/DivisionsPicker.vue";
import AddOnPicker from "./pickers/AddOnPicker.vue";
import ObjectivePicker from "./pickers/ObjectivePicker.vue";
const steps = [
  {
    title: "50",
  },
  {
    title: "650",
  },
  {
    title: "1250",
  },
];
const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();

const priorityOption = gameStore.getGamePack?.pack_options?.find(
  (op) => op.const_title === "standard" && op.slug === "division_priority"
);
const qualificationpriorityOption = gameStore.getGamePack?.pack_options?.find(
  (op) => op.const_title === "standard" && op.slug === "qualification_priority"
);

const handleDetails = () => {
  checkoutStore.clearCheckout();
  checkoutStore.setPlatform({
    platform: 1,
  });
  checkoutStore.setDetails({
    boostType: "Division Boost",
    optionSlabs: [],
  });

  if (priorityOption) {
    checkoutStore.setPackOptions({
      options: [priorityOption.id],
    });
  }

  checkoutStore.setGameAndPack({
    game: gameStore.getGame.id,
    pack: gameStore.getGamePack.id,
    fullGame: gameStore.getGame,
    fullPack: gameStore.getGamePack,
  });
};
handleDetails();

onNuxtReady(() => {
  checkoutStore.setCalculating();
});

watch(
  () => checkoutStore.getDetails?.boostType,
  (newVal) => {
    if (newVal === "Qualification Points") {
      delete checkoutStore.details?.optionSlabs;
      checkoutStore.setDetails({
        ...checkoutStore.getDetails,
        numberOfRivalPoints: 50,
      });

      if (qualificationpriorityOption) {
        checkoutStore.setPackOptions({
          options: [qualificationpriorityOption.id],
        });
      }
    } else if (newVal == "Division Boost") {
      delete checkoutStore.details?.numberOfRivalPoints;
      checkoutStore.setDetails({
        ...checkoutStore.getDetails,
        optionSlabs: [],
      });

      if (priorityOption) {
        checkoutStore.setPackOptions({
          options: [priorityOption.id],
        });
      }
    }
  },
  {
    deep: true,
  }
);
</script>
